import { render, staticRenderFns } from "./CategoryFilter.vue?vue&type=template&id=38fc95be&scoped=true"
import script from "./CategoryFilter.vue?vue&type=script&lang=js"
export * from "./CategoryFilter.vue?vue&type=script&lang=js"
import style0 from "./CategoryFilter.vue?vue&type=style&index=0&id=38fc95be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fc95be",
  null
  
)

export default component.exports